import { createEntityAdapter, createSlice, EntityState } from "@reduxjs/toolkit";
import { ICmsItem } from "../../api/dto/cms/ICmsItem";
import { getAllCmsDataThunk, getCmsDataThunk, publishCmsDataThunk } from "./cmsActionAsync";

export interface PagesSectionState extends EntityState<ICmsItem> {
  isLoading: boolean;
  cmsInfo?: ICmsItem;
  cmsList?: ICmsItem[];
}

export const sectionDataAdapter = createEntityAdapter<ICmsItem>();

export const pagesSectionInitialState: PagesSectionState = sectionDataAdapter.getInitialState({
  isLoading: false,
  cmsInfo: undefined,
  cmsList: []
});

export const cmsSlice = createSlice({
  name: "sectionData",
  initialState: pagesSectionInitialState,
  reducers: {
    clean: (state) => {
      state.isLoading = false;
      state.cmsInfo = undefined;
      state.cmsList = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCmsDataThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCmsDataThunk.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.cmsInfo = payload?.jsonData
          ? { type: payload.type, jsonData: JSON.parse(payload?.type), title: payload.title, link: payload.link }
          : undefined;
      })
      .addCase(getCmsDataThunk.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getAllCmsDataThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllCmsDataThunk.fulfilled, (state, { payload }) => {
        console.log("payload", payload);
        state.isLoading = false;
        sectionDataAdapter.setAll(state, payload);
      })
      .addCase(getAllCmsDataThunk.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(publishCmsDataThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(publishCmsDataThunk.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        //TODO: добавить сохранения в стор и отказаться от обновления после сохранения
        // sectionDataAdapter.setOne(state, payload);
      })
      .addCase(publishCmsDataThunk.rejected, (state) => {
        state.isLoading = false;
      });
  }
});
